import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import reportWebVitals from './reportWebVitals';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/font_size.min.js'; // Import the font size plugin
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/inline_style.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/video.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/emoticons.min.js';
import 'froala-editor/js/plugins/special_characters.min.js';
import 'froala-editor/js/plugins/print.min.js';
import 'froala-editor/js/plugins/help.min.js';
// import 'froala-editor/js/plugins/undo.min.js';
// import 'froala-editor/js/plugins/redo.min.js';
declare global {
  interface Window {
    LIVE_URL: string;
  }
}
// Check if we're on a live route and prevent chatbot loading
if (window.location.pathname.includes('/live/') || window.location.pathname.includes('/preview')) {
  // Find and remove the chatbot script if it exists
  const scripts = document.querySelectorAll('script');
  scripts.forEach(script => {
    if (script.innerHTML && script.innerHTML.includes('venturepact83.chatbotbuilder.net')) {
      script.remove();
    }
    if (script.src && script.src.includes('embed.js')) {
      script.remove();
    }
  });
  
  // Also clean up any DOM elements created by the chatbot
  const cleanup = () => {
    document.querySelectorAll('[id*="chatbot"], [class*="chatbot"], [id*="chat-bot"], [class*="chat-bot"], .omniengage')
      .forEach(el => {
        if (el instanceof HTMLElement) {
          el.style.display = 'none';
        }
      });
  };
  
  // Run cleanup immediately
  cleanup();
  
  // And set up an observer to keep cleaning up
  const observer = new MutationObserver(cleanup);
  observer.observe(document.body, { childList: true, subtree: true });
} else {
  // Only load chatbot on non-live routes
  // This replaces the script in the index.html
  const loadChatbot = () => {
    window.LIVE_URL = "https://venturepact83.chatbotbuilder.net/venturepact83-2?embed=true";
    const d = document;
    const s = d.createElement("script");
    s.src = "https://venturepact83.chatbotbuilder.net/embed.js";
    s.defer = true;
    d.getElementsByTagName("head")[0].appendChild(s);
  };
  
  // Wait for the DOM to be ready before loading the chatbot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadChatbot);
  } else {
    loadChatbot();
  }
}
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// src/index.js or main entry file
if (process.env.REACT_APP_PROJECT_ENV === 'production') {
  console.log = function () {}; // Overwrites console.log to no-op in production
  console.warn = function () {}; // Optional: Disable console.warn in production
  console.error = function () {}; // Optional: Disable console.error in production
}

root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}>
      <App />
    </GoogleOAuthProvider>
   
);

reportWebVitals();

